export function debounce(func: (...args: any[]) => void, timeout: number = 300): (...args: any[]) => void {
    let timer: ReturnType<typeof setTimeout> | undefined;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func(...args); }, timeout);
    };
}